import { Routes } from '@angular/router';
import { globaleResolverResolver } from './Security/resolvers/glbale-resolver.resolver';
import { sessionIdValidationGuard } from './Security/session-id-validation.guard';
import { ibanResolverResolver } from './Injection-resolver/iban-resolver.resolver';
import { cryptoResolverResolver } from './Injection-resolver/crypto-resolver.resolver';
import { initResolver } from './GlobaleResolver/init-resolver';

export const routes: Routes = [
  // -----------------------------------------------------------
  // UNIVERSAL, LAZY-LOADED GOOGLE ANALYTICS INTEGRATION
  // This route loads the GoogleServiceComponent into a secondary outlet
  // alongside any primary route that matches the path: '' (i.e., almost all routes).
  // -----------------------------------------------------------
  {
    path: '',
    outlet: 'analytics',
    loadComponent: () =>
      import('./google-service/google-service.component').then(m => m.GoogleServiceComponent),
  },

  {
    path: 'v2/:mop/:id',
    resolve: { r: initResolver },
    loadComponent: () =>
      import('./GlobaleResolver/entry/entry.component').then(module => module.EntryComponent),
  },
  {
    path: 'master-v2/:id',
    loadComponent: () =>
      import('./Pages/pci-three-ds/pci-three-ds.component').then(m => m.PciThreeDsComponent),
  },
  {
    path: 'pay',
    loadComponent: () =>
      import('./Pages/deposit/providers.component').then(module => module.ProvidersComponent),
    resolve: {
      sessionData: globaleResolverResolver,
    },
    canActivate: [sessionIdValidationGuard],
  },
  {
    path: 'card',
    loadComponent: () =>
      import('./Pages/deposit/card/card.component').then(module => module.CardComponent),
  },
  {
    path: 'botim',
    loadComponent: () =>
      import('./Pages/deposit/botim/botim.component').then(module => module.BotimComponent),
  },
  {
    path: 'botim/refund',
    loadComponent: () =>
      import('./Pages/refund/botim/botim.component').then(module => module.BotimRefundComponent),
  },
  {
    path: 'card/refund',
    loadComponent: () =>
      import('./Pages/refund/card/card.component').then(module => module.CardComponent),
  },
  {
    path: 'gatetopay',
    loadComponent: () =>
      import('./Pages/deposit/gatetopay/gatetopay.component').then(
        module => module.GatetopayComponent
      ),
  },
  {
    path: 'gatetopay/refund',
    loadComponent: () =>
      import('./Pages/refund/gatetopay/gatetopay.component').then(
        module => module.GatetopayComponent
      ),
  },
  {
    path: 'pci',
    loadComponent: () =>
      import('./Pages/deposit/pci/card/card.component').then(module => module.CardComponent),
  },
  {
    path: 'apple-pci',
    loadComponent: () =>
      import('./Pages/deposit/pci/apple-pay/apple-pay.component').then(
        module => module.ApplePayComponent
      ),
  },
  {
    path: 'pci/equiti',
    loadComponent: () =>
      import('./Pages/deposit/pci/old-card/old-card.component').then(
        module => module.OldCardComponent
      ),
  },
  {
    path: 'neo-bank',
    loadComponent: () =>
      import('./Pages/deposit/neo-bank-mobile/neo-bank-mobile.component').then(
        module => module.NeoBankMobileComponent
      ),
  },
  {
    path: 'neo-bank/refund',
    loadComponent: () =>
      import('./Pages/refund/neo-bank/neo-bank.component').then(module => module.NeoBankComponent),
  },
  {
    path: 'crypto',
    loadComponent: () =>
      import('./Pages/deposit/crypto/crypto.component').then(module => module.CryptoComponent),
  },
  {
    path: 'google-pay',
    loadComponent: () =>
      import('./Pages/deposit/pci/google-pay-decryption/google-pay-decryption.component').then(
        module => module.GooglePayDecryptionComponent
      ),
  },

  {
    path: 'cliq',
    loadComponent: () =>
      import('./Pages/deposit/domestic-bank/domestic-bank.component').then(
        module => module.DomesticBankComponent
      ),
  },
  {
    path: 'bank-withrawal',
    loadComponent: () =>
      import('./Pages/deposit/bank/transfer-withdrawal/transfer-withdrawal.component').then(
        module => module.TransferWithdrawalComponent
      ),
  },
  {
    path: 'googlePay/refund',
    loadComponent: () =>
      import('./Pages/refund/digital-wallet/digital-wallet.component').then(
        module => module.DigitalWalletComponent
      ),
  },
  {
    path: 'applePay',
    loadComponent: () =>
      import('./Pages/deposit/apple/apple.component').then(module => module.AppleComponent),
    resolve: {
      appledata: globaleResolverResolver,
    },
  },
  {
    path: 'applePay/refund',
    loadComponent: () =>
      import('./Pages/refund/digital-wallet/digital-wallet.component').then(
        module => module.DigitalWalletComponent
      ),
  },
  {
    path: '404',
    loadComponent: () =>
      import('./Pages/Status/404/404.component').then(module => module.NotFondComponent),
  },
  {
    path: 'm3ds/:id',
    loadComponent: () =>
      import('./Pages/deposit/mobile/m3ds/m3ds.component').then(module => module.M3dsComponent),
  },
  {
    path: '3ds',
    loadComponent: () =>
      import('./Pages/tree-ds/tree-ds.component').then(module => module.TreeDsComponent),
  },
  {
    path: '3ds-fl',
    loadComponent: () =>
      import('./tree-ds-fl/tree-ds-fl.component').then(module => module.TreeDsFlComponent),
  },
  {
    path: 'cashier',
    loadComponent: () =>
      import('./Pages/deposit/payment-methode/payment-methode.component').then(
        module => module.PaymentMethodeComponent
      ),
  },
  {
    path: 'rdc',
    loadComponent: () => import('./Pages/rdc/rdc.component').then(module => module.RdcComponent),
  },
  {
    path: 'pross',
    loadComponent: () =>
      import('./Pages/pross/pross.component').then(module => module.ProssComponent),
  },
  {
    path: 'payment-result',
    loadComponent: () =>
      import('./Pages/Status/cash-requested/cash-requested.component').then(
        module => module.CashRequestedComponent
      ),
  },
  {
    path: 'Confirm',
    loadComponent: () =>
      import('./Pages/Status/transaction-confirmed/transaction-confirmed.component').then(
        module => module.TransactionConfirmedComponent
      ),
  },
  {
    path: 'neo-bank-v2',
    loadComponent: () =>
      import('./Pages/deposit/neo-bank-mobile-v2/neo-bank-mobile-v2.component').then(
        module => module.NeoBankMobileV2Component
      ),
  },
  {
    path: 'neo-bank-v3',
    loadComponent: () =>
      import('./Pages/deposit/neo-bank-v3/neo-bank-v3.component').then(
        module => module.NeoBankV3Component
      ),
  },
  {
    path: 'reject',
    loadComponent: () =>
      import('./Pages/Status/transaction-aborted/transaction-aborted.component').then(
        module => module.TransactionAbortedComponent
      ),
  },
  {
    path: 'transaction-canceled',
    loadComponent: () =>
      import('./Pages/Status/transaction-canceled/transaction-canceled.component').then(
        module => module.TransactionCanceledComponent
      ),
  },
  {
    path: 'request',
    loadComponent: () =>
      import('./Pages/Status/cash-requested/cash-requested.component').then(
        module => module.CashRequestedComponent
      ),
  },
  {
    path: 'bank-request',
    loadComponent: () =>
      import('./Pages/Status/bank-withrawal-requested/bank-withrawal-requested.component').then(
        module => module.BankWithrawalRequestedComponent
      ),
  },
  {
    path: 'withrawal-Confirm',
    loadComponent: () =>
      import('./Pages/Status/withrawal-confirmed/withrawal-confirmed.component').then(
        module => module.WithrawalConfirmedComponent
      ),
  },
  {
    path: 'withrawal-request',
    loadComponent: () =>
      import('./Pages/Status/withrawal-requested/withrawal-requested.component').then(
        module => module.WithrawalRequestedComponent
      ),
  },
  {
    path: 'cash-withrawal-request',
    loadComponent: () =>
      import('./Pages/Status/cash-withrawal-requested/cash-withrawal-requested.component').then(
        module => module.CashWithrawalRequestedComponent
      ),
  },
  {
    path: 'refund-Confirm',
    loadComponent: () =>
      import('./Pages/Status/refund-confirmed/refund-confirmed.component').then(
        module => module.RefundConfirmedComponent
      ),
  },
  {
    path: 'refund-reject',
    loadComponent: () =>
      import('./Pages/Status/refund-aborted/refund-aborted.component').then(
        module => module.RefundAbortedComponent
      ),
  },
  {
    path: 'deposit/sm_pay',
    loadComponent: () =>
      import('./Pages/deposit/domestic-solution/sm-pay/sm-pay.component').then(
        module => module.SmPayComponent
      ),
  },
  {
    path: 'bank-transfer-deposit/:id',
    loadComponent: () =>
      import('./Pages/deposit/bank/transfer-deposit/transfer-deposit.component').then(
        module => module.TransferDepositComponent
      ),
    resolve: {
      iban: ibanResolverResolver,
    },
  },
  {
    path: 'bank-transfer-withdrawal',
    loadComponent: () =>
      import('./Pages/deposit/bank/transfer-withdrawal/transfer-withdrawal.component').then(
        module => module.TransferWithdrawalComponent
      ),
  },
  {
    path: 'cash',
    loadComponent: () =>
      import('./Pages/deposit/vision/vision.component').then(module => module.VisionComponent),
  },
  {
    path: 'cash-refund',
    loadComponent: () =>
      import('./Pages/refund/vision/vision.component').then(module => module.VisionComponent),
  },
  {
    path: 'recurring-payment',
    loadComponent: () =>
      import('./Pages/deposit/pci/recurring-payment/recurring-payment.component').then(
        module => module.RecurringPaymentComponent
      ),
  },

  {
    path: 'ngenius',
    loadComponent: () =>
      import('./Pages/deposit/ngenius/ngenius.component').then(module => module.NgeniusComponent),
  },
  {
    path: 'mobile-money',
    loadComponent: () =>
      import('./Pages/deposit/mobile-money/mobile-money.component').then(
        module => module.MobileMoneyComponent
      ),
  },
  {
    path: 'mobile-money/refund',
    loadComponent: () =>
      import('./Pages/refund/mobile-money/mobile-money.component').then(
        module => module.MobileMoneyComponent
      ),
  },
  {
    path: 'mobile-refund-aborted',
    loadComponent: () =>
      import('./Pages/Status/mobile-refund-aborted/mobile-refund-aborted.component').then(
        module => module.MobileRefundAbortedComponent
      ),
  },
  {
    path: 'mobile-refund-confirmed',
    loadComponent: () =>
      import('./Pages/Status/mobile-refund-confirmed/mobile-refund-confirmed.component').then(
        module => module.MobileRefundConfirmedComponent
      ),
  },

  {
    path: 'neo-bank-withdrawal-confirmed',
    loadComponent: () =>
      import('./Pages/Status/neo-bank-withdrawal-requested/neo-bank-withdrawal-requested.component').then(
        module => module.NeoBankWithdrawalRequestedComponent
      ),
  },
  {
    resolve: { listOfCryptoAdrees: cryptoResolverResolver },
    path: 'refund/crypto/:id',
    loadComponent: () =>
      import('./Pages/refund/crypto/crypto.component').then(module => module.CryptoComponent),
  },
  {
    path: 'deposit/:mop',
    loadComponent: () =>
      import('./Pages/deposit/domestic-solution/domestic-solution.component').then(
        module => module.DomesticSolutionComponent
      ),
  },
  {
    path: 'withdrawal/:id',
    loadComponent: () =>
      import('./Pages/refund/domestic-solution/domestic-solution.component').then(
        module => module.DomesticSolutionComponent
      ),
  },
  {
    path: 'mpesa',
    loadComponent: () =>
      import('./Pages/deposit/mpesa/mpesa.component').then(module => module.MpesaComponent),
  },
  {
    path: 'paybill',
    loadComponent: () =>
      import('./Pages/deposit/mpesa/mpesa.component').then(module => module.MpesaComponent),
  },
  {
    path: 'mpesa/refund',
    loadComponent: () =>
      import('./Pages/refund/mpesa/mpesa.component').then(module => module.MpesaComponent),
  },
  {
    path: 'final-status/:id',
    loadComponent: () =>
      import('./Pages/Status/final-status/final-status.component').then(
        module => module.FinalStatusComponent
      ),
  },
  {
    path: 'binance_pay',
    loadComponent: () =>
      import('./Pages/deposit/binance-pay/binance-pay.component').then(
        module => module.BinancePayComponent
      ),
  },
  {
    path: 'binance_pay/refund',
    loadComponent: () =>
      import('./Pages/refund/binance-pay/binance-pay.component').then(
        module => module.BinancePayComponent
      ),
  },
  {
    path: 'transaction-processing',
    loadComponent: () =>
      import('./Pages/Status/transaction-processing/transaction-processing.component').then(
        module => module.TransactionProcessingComponent
      ),
  },
  {
    path: 'paysafe',
    loadComponent: () =>
      import('./Pages/deposit/paysafe/paysafe.component').then(module => module.PaysafeComponent),
  },
  {
    path: 'paysafe/refund',
    loadComponent: () =>
      import('./Pages/refund/paysafe/paysafe.component').then(module => module.PaysafeComponent),
  },
  {
    path: '',
    redirectTo: '/404',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];

// const load = (path: string, component: string) => () => import(`./${path}`).then(m => m[component]);
//
// export const routesv2: Routes = [
//   { path: 'server/:route/:id', resolve: { r: serverResolver }, loadComponent: load('GlobaleResolver/staticSwitsh/switsh/switsh.component', 'SwitshComponent') },
//   { path: 'pay', canActivate: [sessionIdValidationGuard], resolve: { sessionData: globaleResolverResolver }, loadComponent: load('Pages/deposit/providers.component', 'ProvidersComponent') },
//   { path: 'card', loadComponent: load('Pages/deposit/card/card.component', 'CardComponent') },
//   { path: 'neo-bank', loadComponent: load('Pages/deposit/neo-bank/neo-bank.component', 'NeoBankComponent') },
//   { path: 'neo-bank/refund', loadComponent: load('Pages/refund/neo-bank/neo-bank.component', 'NeoBankComponent') },
//   { path: 'crypto', loadComponent: load('Pages/deposit/crypto/crypto.component', 'CryptoComponent') },
//   { path: 'bank-withdrawal', loadComponent: load('Pages/deposit/bank/transfer-withdrawal/transfer-withdrawal.component', 'TransferWithdrawalComponent') },
//   { path: 'googlePay', resolve: { googledata: globaleResolverResolver }, loadComponent: load('Pages/deposit/google/google.component', 'GoogleComponent') },
//   { path: 'applePay', resolve: { appledata: globaleResolverResolver }, loadComponent: load('Pages/deposit/apple/apple.component', 'AppleComponent') },
//   { path: '404', loadComponent: load('Pages/Status/404/404.component', 'NotFondComponent') },
//   { path: 'bank-transfer-deposit/:id', resolve: { iban: ibanResolverResolver }, loadComponent: load('Pages/deposit/bank/transfer-deposit/transfer-deposit.component', 'TransferDepositComponent') },
//   { path: ':id', resolve: { v: initResolver }, loadComponent: load('GlobaleResolver/staticSwitsh/switsh/switsh.component', 'SwitshComponent') },
//   { path: ':id/:lang', resolve: { v: initResolver }, loadComponent: load('GlobaleResolver/staticSwitsh/switsh/switsh.component', 'SwitshComponent') },
//   { path: '**', redirectTo: '404' },
// ];
